export default "__VITE_ASSET__BjPbdgZJ__"